import axios from "axios";
import ConfigConnection from "../config/config.service";
import { buildURL } from "../../utils/dynamicQueryParams";
export default class CandidateService {
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage, filtersToApply) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };

    const filtersToSend = {};
    if (filtersToApply) {
      for (const [key, value] of Object.entries(filtersToApply)) {
        if (value) {
          filtersToSend[key] = value;
        }
      }
    }

    const endpointUrl = buildURL(
      `${_.configConnection.apiInstance}candidate?offset=${pageOffset}&limit=${itemsPerPage}`,
      filtersToSend
    );
    return axios.get(endpointUrl, config);
  }

  create(candidate) {
    const _ = this;
    console.log(candidate);
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}candidate`,
      candidate,
      config
    );
  }

  edit(user, userId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.put(
      `${_.configConnection.apiInstance}user/${userId}`,
      user,
      config
    );
  }

  getCompletedSurveys() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}candidate/completed`,
      config
    );
  }

  getById(userId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}user/${userId}`, config);
  }

  getByJob(jobId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}job/${jobId}`, config);
  }

  delete_user(user_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.delete(
      `${_.configConnection.apiInstance}user/${user_id}`,
      config
    );
  }

  getCompanies() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  getJobs() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}job`, config);
  }

  getReporters() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}user/reporters`, config);
  }

  assingCompanies(user_id, company_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}user/${user_id}/company`,
      { company_id: company_id },
      config
    );
  }

  getInactive(pageOffset, itemsPerPage) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/candidate/inactive?offset=${pageOffset}&limit=${itemsPerPage}`,
      config
    );
  }

  active_user(user_id, reactivate) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/${user_id}/reactivate`,
      config
    );
  }

  getProfileReport(userSurveyId, profileId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}test/${userSurveyId}/report`,
      profileId,
      config
    );
  }

  getSingleReport(userSurveyId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/${userSurveyId}/report`,
      config
    );
  }

  public getCompanySurveys(companyId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}company/${companyId}/surveys`,
      config
    );
  }

  downloadMonthlyReport(
    companyId: string,
    startDate: string,
    endDate: string,
    reportType: string
  ) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
      responseType: "blob",
    };
    return axios.get(
      `${_.configConnection.apiInstance}company/${companyId}/monthly-progress-report?start_date=${startDate}&end_date=${endDate}&report_type=${reportType}`,
      config
    );
  }
}
